import React, { ChangeEvent, useCallback } from 'react';
import { Checkbox } from '@app/form';
import { useDebouncedHandleChange } from './useDebounce';
import { useTranslation } from 'react-i18next';

interface Props {
  debouncedSetFilter: (val?: any) => any;
  setValue: (val?: any) => void;
  value: any;
}

export const IsEmptyCheckboxFilter = ({
  debouncedSetFilter,
  setValue,
  value,
}: Props) => {
  const { t } = useTranslation();
  const emptySelectCheck = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      const { checked } = e.currentTarget;
      if (checked) {
        setValue(null);
        return debouncedSetFilter(null);
      }
      if (!checked) {
        setValue(undefined);
        return debouncedSetFilter(undefined);
      }
    },
    [debouncedSetFilter, setValue],
  );

  const handleEmptySelectCheck = useDebouncedHandleChange(emptySelectCheck);

  return (
    <Checkbox
      label={t('participants.list.filters.empty')}
      noMargin
      checked={value === null}
      onChange={handleEmptySelectCheck}
    />
  );
};
